const SUPPORTED_MIME_TYPES = [
  'audio/webm;codecs=opus',
  'audio/webm',
  'audio/ogg;codecs=opus',
  'audio/ogg',
  'audio/mp4',
  'audio/wav',
]

export function getSupportedMimeType(): string {
  const supported = SUPPORTED_MIME_TYPES.find((mimeType) =>
    MediaRecorder.isTypeSupported(mimeType),
  )

  if (!supported) {
    console.warn('No preferred MIME types supported, using browser default')
  }

  return supported || ''
}

export function stopMediaStreamTracks(stream: MediaStream | null): void {
  if (stream) {
    stream.getTracks().forEach((track) => track.stop())
  }
}
